// src/components/OrderScreen.js
import React from 'react';
import { useKiosk } from '../context/KioskContext';
import { ArrowLeft, Trash2, CheckCircle } from 'lucide-react';
import './OrderScreen.css';

const OrderScreen = ({ onHome }) => {
  const { currentOrder, getTotalPrice, clearOrder, removeFromOrder } = useKiosk();

  const handleCheckout = () => {
    const confirmed = window.confirm(`Confirm your order?\n\nTotal: £${getTotalPrice()}\n\nThank you for choosing HeySalad!`);
    if (confirmed) {
      clearOrder();
      onHome();
    }
  };

  return (
    <div className="order-screen">
      {/* Animated Background Elements */}
      <div className="bg-element bg-element-1" />
      <div className="bg-element bg-element-2" />

      {/* Header with Logo */}
      <div className="order-header">
        <div className="heysalad-logo">
          <img src="/HeySalad Logo White.png" alt="HeySalad" className="logo-image" />
        </div>
        <h1 className="order-title">Your Order</h1>
        <p className="order-subtitle">Review your delicious selections</p>
      </div>
      
      <div className="order-content">
        {currentOrder.length === 0 ? (
          <div className="empty-order">
            <div className="empty-order-card">
              <h3>Your order is empty</h3>
              <p>Add some delicious items from our menu to get started!</p>
              <button 
                onClick={onHome}
                className="back-to-menu-button"
              >
                <ArrowLeft size={20} />
                Back to Menu
              </button>
            </div>
          </div>
        ) : (
          <>
            {/* Order Items */}
            <div className="order-items">
              {currentOrder.map((item, index) => (
                <div key={index} className="order-item-card">
                  {item.image && (
                    <div className="order-item-image">
                      <img src={item.image} alt={item.name} />
                    </div>
                  )}
                  <div className="order-item-info">
                    <h4 className="order-item-name">{item.name}</h4>
                    <p className="order-item-description">{item.description}</p>
                    <div className="order-item-details">
                      <span className="order-item-calories">{item.calories} cal</span>
                      <div className="dietary-tags">
                        {item.dietary.map(tag => (
                          <span key={tag} className="dietary-tag">{tag}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="order-item-actions">
                    <span className="order-item-price">£{item.price}</span>
                    <button 
                      onClick={() => removeFromOrder(item.orderId)}
                      className="remove-item-button"
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Order Summary */}
            <div className="order-summary">
              <div className="summary-card">
                <div className="summary-row total">
                  <span>Total ({currentOrder.length} items)</span>
                  <span>£{getTotalPrice()}</span>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="order-actions">
              <button 
                onClick={onHome}
                className="back-button"
              >
                <ArrowLeft size={20} />
                Add More Items
              </button>
              
              <button 
                onClick={handleCheckout}
                className="confirm-button"
              >
                <CheckCircle size={20} />
                Confirm Order
              </button>
            </div>
          </>
        )}
      </div>

      {/* Footer */}
      <div className="order-footer">
        <p>Powered by GPT-OSS • Running Offline • Built for OpenAI Hackathon</p>
      </div>
    </div>
  );
};

export default OrderScreen;